import React from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Dropdown, Radio, Select, Tooltip, Form, List, Card, Tabs, Menu, Input, Layout, Row, Col, Icon, Button, Tree, Avatar } from 'antd';
import { CATEGORY_COLOR, QUERY_COLOR } from '../../Tabs/entityColors';

const EntityIcon = ({ type }) => (
  <Icon
    type="inbox"
    style={{
      /*boxShadow: `0px 0px 0px 4px ${type === 'category' ? CATEGORY_COLOR : QUERY_COLOR}`,*/
      border: `4px ${type === 'category' ? CATEGORY_COLOR : QUERY_COLOR} solid`,
      color: '#fff',
      borderRadius: '4px',
      background: type === 'category' ? CATEGORY_COLOR : QUERY_COLOR,
    }}
  />
);

export default EntityIcon;
